import { Skeleton } from 'antd'

export default function LoadingContents() {
  return (
    <div>
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    </div>
  )
}
